// extracted by mini-css-extract-plugin
module.exports = {"footer":"MutateMid_footer__3guYS","legacyBtn":"MutateMid_legacyBtn__3L3Lv"};